import QrScanner from "qr-scanner";
import onScan from "onscan.js";
QrScanner.WORKER_PATH = "../scripts/qr-scanner-worker.min.js";
import moment from "moment";

export default {
	computed: {
		isChPage() {
			return window.location.hostname.toLowerCase().endsWith(".ch");
		},
		scanResultCssClass() {
			switch (this.scanResult.Status) {
				case "OK":
					return "scanResult scanResult--valid";
				case "AlreadyCheckedIn":
				case "AlreadyCheckedOut":
					return "scanResult scanResult--warning";
				default:
					return "scanResult scanResult--invalid";
			}
		},
	},
	data() {
		return {
			countDownTimerInterval: null,
			countDownSeconds: 20,
			countDown: 8,
			isQrCodeResolved: false,
			isDone: false,
			isInvalidResult: false,
			isLoading: false,
			timestamp: null,
			code: null,
			products: [],
			totalOccupancy: null,
			hasCamera: false,
			isHardwareScannerInitialized: false,
			scanner: null,
			period: {
				date: null,
				startTime: null,
				endTime: null
			},
			messages: [],
			reservationStatus: null,
			qrCode: null,
			status: null,
			scanResult: null,
			guestCount: null
		};
	},
	filters: {
		date(value, format) {
			return moment(value).format(format);
		}
	},
	methods: {
		getCookie(name) {
			var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
			return match ? match[2] : null;
		},
		getTime(date) {
			return moment(date).format("HH:mm");
		},
		countDownTimer() {
			if (this.countDownTimerInterval !== null)
				window.clearInterval(this.countDownTimerInterval);
			this.countDownTimerInterval = window.setInterval(() => {
				this.countDown -= 1;
				if (this.countDown === 0) {
					this.newScan();
				}
			}, 1000);
		},
		initScanner() {
			if (this.isHardwareScannerInitialized) return;

			onScan.attachTo(document, {
				onKeyDetect(keyCode, oEvent) {
					if (oEvent && oEvent.target && oEvent.target.id === "scanner-input") {
						return false;
					}
				},
				onPaste: pasted => {
					this.qrCode = pasted;
				},
				onScan: (sCode, iQty) => {
					if (sCode && sCode !== "v" && !this.isDone) {
						console.log(sCode);
						// Alternative to document.addEventListener('scan')
						this.scan(sCode, false);
					}
				},
				keyCodeMapper: oEvent => {
					// Look for special keycodes or other event properties specific to
					// your scanner
					if (oEvent.key === "-" || oEvent.key === "/" || oEvent.key === "ß") {
						return "-";
					}
					// Fall back to the default decoder in all other cases
					return onScan.decodeKeyEvent(oEvent);
				},
				scanButtonKeyCode: true,
				scanButtonLongPressTime: 500,
				timeBeforeScanTest: 100,
				avgTimeByChar: 30,
				minLength: 1,
				suffixKeyCodes: [9, 13],
				prefixKeyCodes: [],
				ignoreIfFocusOn: false,
				stopPropagation: false,
				preventDefault: false,
				reactToKeydown: true,
				reactToPaste: true,
				singleScanQty: 1,
				reactToKeyDown: true
			});

			this.isHardwareScannerInitialized = true;
		},
		isValidQrCode(qrCode) {
			return qrCode && qrCode.length >= 15;
		},
		newScan(isFromInput) {
			//
			if (this.countDownTimerInterval !== null) {
				window.clearInterval(this.countDownTimerInterval);
				this.countDownTimerInterval = null;
			}
			this.responseStatus = null;
			this.isQrCodeResolved = false;
			this.isDone = false;
			if (!isFromInput) {
				this.qrCode = null;
			}

			this.$nextTick().then(() => {
				this.start();
			});

			window.setTimeout(() => {
				this.isInvalidResult = false;
			}, 5000);
		},
		onScanDone() {
			this.countDown = this.scanResult.Persons && this.scanResult.Persons.length > 0 ? 60 : this.countDownSeconds;
			this.countDownTimer();
		},
		onShowScanResult(scanResult) {
			//
			this.scanResult = scanResult;
			this.onScanDone();
		},
		scan(code, isFromInput) {
			if (!this.isValidQrCode(code)) return;
			this.isLoading = true;
			this.isInvalidResult = false;

			//
			const request = {
				method: "POST",
				headers: {
					"CSRF-Token": this.getCookie("XSRF-TOKEN"),
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					code: code.toUpperCase()
				})
			};

			var directory = this.$route.params.directory || "public";
			var action = this.$route.params.action && this.$route.params.action.toLowerCase() === "check-out" ? "checkOut" : "checkIn";
			const staging = ["1", "true"].includes(this.$route.query.staging);
			let url = `/api/scan/${directory}/${action}`;
			if (staging) {
				url += "?staging=true"
			}

			fetch(url, request).then(response => {
				response.json().then(result => {
					if (result && result.Data) {
						this.onShowScanResult(result);
						this.isDone = true;
					} else {
						this.isInvalidResult = true;
						window.setTimeout(() => {
							this.newScan(isFromInput);
						}, 600);
					}

					//
					this.isLoading = false;
				});
			});
		},
		start() {
			window.QrScanner = QrScanner;
			const video = document.getElementById("qr-video");

			// Enable scan events for the entire document
			// Register event listener
			this.scanner = null;
			this.scanner = new QrScanner(video, code => {
				if (code && !this.isQrCodeResolved) {
					//
					this.isQrCodeResolved = true;
					this.stopAll();
					this.scan(code);
				}
			});

			//
			this.scanner.start();
		},
		stopAll() {
			this.scanner.stop();
		},
	},
	mounted() {
		//
		moment.locale("de-DE");

		//
		if (this.isChPage) {
			var css = document.createElement("link");
			css.setAttribute("rel", "stylesheet");
			css.setAttribute("type", "text/css");
			css.setAttribute("href", "/themes/fc-schaffhausen/theme.css");
			document.getElementsByTagName("head")[0].appendChild(css);
			var ico = document.createElement("link");
			ico.setAttribute("rel", "shortcut icon");
			ico.setAttribute("href", "/themes/fc-schaffhausen/favicon.ico");
			document.getElementsByTagName("head")[0].appendChild(ico);
		}

		//
		QrScanner.hasCamera().then(hasCamera => {
			//
			this.hasCamera = hasCamera;
			this.start();
		});

		//
		this.initScanner();
	}
}